var React = require('react');

function Developers (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.9"},[React.createElement("path",{"d":"M0 47.2773L12.2216 67.6049L37.0046 0L0 47.2773Z","fill":"#F8BFDD","key":0}),React.createElement("path",{"d":"M12.2217 67.6049H61.7876L37.0046 0L12.2217 67.6049Z","fill":"#F066AF","key":1}),React.createElement("path",{"d":"M61.7869 67.6049L74.0002 47.2773L37.0039 0L61.7869 67.6049Z","fill":"#E6007A","key":2})]));
}

Developers.defaultProps = {"width":"74","height":"68","viewBox":"0 0 74 68","fill":"none"};

module.exports = Developers;

Developers.default = Developers;
